import Page from "webPage/Page";
import Distributors from "../Distributors";

Page.register("page-template-find-a-distributor", () => {
    let $distributors = $('.js-distributors');
    if ($distributors.length > 0) {
        new Distributors($distributors);
    }
});